import { render, staticRenderFns } from "./AddPersonalHandleTicket.vue?vue&type=template&id=ed841912&scoped=true"
import script from "./AddPersonalHandleTicket.vue?vue&type=script&lang=js"
export * from "./AddPersonalHandleTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed841912",
  null
  
)

export default component.exports